module.exports = __webpack_public_path__ + "7e961ae843b534969f47eaa93b3e9691.gif";